import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent, classNamesFunction } from '../../Utilities';
import { Icon } from '../../Icon';
var getClassNames = classNamesFunction();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardStatusBase = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardStatusBase, _super);
    function DocumentCardStatusBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardStatusBase.prototype.render = function () {
        var _a = this.props, statusIcon = _a.statusIcon, status = _a.status, styles = _a.styles, theme = _a.theme, className = _a.className;
        var iconProps = {
            iconName: statusIcon,
            styles: {
                root: { padding: '8px' }
            }
        };
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (React.createElement("div", { className: this._classNames.root },
            statusIcon && React.createElement(Icon, tslib_1.__assign({}, iconProps)),
            status));
    };
    return DocumentCardStatusBase;
}(BaseComponent));
export { DocumentCardStatusBase };
//# sourceMappingURL=DocumentCardStatus.base.js.map